import { useApiClient } from '@chilipiper/api-client/src/context'
import { useQuery } from '@tanstack/react-query'

const queryKeys = {
  dataFields: (tenantId: string, ref: string[]) => ['dataFields', tenantId, ref],
}
export const useDataFields = (tenantId: string, ref: string[]) => {
  const { chiliCrm } = useApiClient()

  return useQuery({
    queryKey: queryKeys.dataFields(tenantId, ref),
    queryFn: () =>
      chiliCrm.getDataFields(tenantId, {
        ref,
      }),
    enabled: ref.length > 0,
  })
}
